import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ListingService } from '@hosty-app/services';

import { ListingStoreEffects } from './listing-store.effects';
import { listingStoreFeatureKey, reducer } from './listing-store.reducers';

export function provideListingStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(listingStoreFeatureKey, reducer),
    provideEffects([ListingStoreEffects]),
    ListingService,
  ]);
}
